import { TextField, Show, SimpleShowLayout } from 'react-admin'
import { ImageFieldCustom } from '../utils'

export const AgRegistrationShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout
      style={{
        padding: '1rem',
      }}
    >
      <TextField source="id" />
      <TextField source="phone" />
      <TextField source="token" label="Code authentification directe" />
      <TextField label="Copropriétaire" source="libelle" />
      <ImageFieldCustom
        source="id_path"
        label="Document identité"
        {...props}
        protected={true}
      />
      <ImageFieldCustom source="signature_path" label="Signature" {...props} />
    </SimpleShowLayout>
  </Show>
)
